import { memo } from 'react';
import { ForgotIdTemplate } from 'components/templates/ForgotIdTemplate';

type Props = {};

export const ForgotIdPage = memo((_props: Props) => {
	return <ForgotIdTemplate />;
});
